var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinStack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coin-stack"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.3119 4.07257C12.3129 3.04942 10.2265 2.2207 7.65592 2.2207C5.0853 2.2207 3.00086 3.05034 2.99899 4.07257M2.99899 4.07257C2.99899 5.09573 5.08343 5.92445 7.65592 5.92445C10.2284 5.92445 12.3129 5.09573 12.3129 4.07257L12.3129 11.2578M2.99899 4.07257V15.1837C2.99992 16.2069 5.08437 17.0356 7.65592 17.0356C8.90305 17.0356 10.0291 16.8384 10.8646 16.5208M2.99992 7.7763C2.99992 8.79946 5.08437 9.62817 7.65686 9.62817C10.2293 9.62817 12.3138 8.79946 12.3138 7.7763M10.9204 12.7996C10.0803 13.1283 8.9282 13.332 7.65592 13.332C5.08437 13.332 2.99992 12.5033 2.99992 11.4801M17.605 11.7746C19.2414 13.4014 19.2414 16.0404 17.605 17.6672C15.9685 19.2941 13.3141 19.2941 11.6777 17.6672C10.0412 16.0404 10.0412 13.4014 11.6777 11.7746C13.3141 10.1477 15.9685 10.1477 17.605 11.7746Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinStack);
export default __webpack_public_path__ + "static/media/coinStack.57bcf6b574af0ee8f037e84ab26802e5.svg";
export { ForwardRef as ReactComponent };